import {ApplicationConfig, ErrorHandler, importProvidersFrom} from '@angular/core';
import {appRoutingProviders, routing} from './player.routes';
import {
    ActivityService,
    B4xLoaderService,
    ConfigService,
    convertConfigToObject,
    CWGAService,
    LocaleService,
    PLAYER_CONFIG
} from '@transparent/coretypes';
import {APP_BASE_HREF, HashLocationStrategy, LocationStrategy, PathLocationStrategy} from '@angular/common';
import {provideAnimations} from '@angular/platform-browser/animations';
import {HttpClientModule} from '@angular/common/http';
import {ConfigLoadGuard} from './guard/config-load-guard';
import {PlayerResolver} from './services/resolver/player.resolver';
import {MessageService} from './services/message.service';
import {MessagePoolService} from './services/message-pool.service';
import {PlayerErrorHandler} from './services/player-error-handler';
import {AudioModule} from '@transparent/cw-audio';
import {MoneCommunicationService} from './services/mone-communication.service';

const lmsLitePat = /lmss\/lite\/lesson\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\//gi;
const playerConfig = convertConfigToObject();
const href = window.location.href;
const isPreviewMode = window === window.parent && (
    window['isPreviewTrialLesson'] ||
    window['isPreviewPublish'] ||
    (/unit[0-9]*\.html/i.test(href) && playerConfig.isLessonGin));

const isLmsLiteCourse = !isPreviewMode && window === window.parent && lmsLitePat.test(href);

export const appConfig: ApplicationConfig = {
    providers: [
        B4xLoaderService,
        ConfigService,
        CWGAService,
        ActivityService,
        LocaleService,
        MoneCommunicationService,
        MessageService,
        MessagePoolService,
        PlayerResolver,
        ConfigLoadGuard,
        importProvidersFrom(HttpClientModule, AudioModule, routing),
        appRoutingProviders,
        {provide: ErrorHandler, useClass: PlayerErrorHandler},
        {
            provide: LocationStrategy,
            useClass: (isPreviewMode || isLmsLiteCourse) ? PathLocationStrategy : HashLocationStrategy
        },
        {provide: PLAYER_CONFIG, useValue: playerConfig},
        provideAnimations()
    ]
};
if (isPreviewMode) {
    appConfig.providers.push({
        provide: APP_BASE_HREF,
        useValue: href.split('/').find((str) => str.includes('.html'))
    });
} else if (isLmsLiteCourse) {
    lmsLitePat.lastIndex = 0;
    appConfig.providers.push({
        provide: APP_BASE_HREF,
        useValue: href.split(lmsLitePat)[0] + href.match(lmsLitePat)[0]
    });
}
